import { status } from "../_constants/commanLHd";
import { homeConstant } from "../_constants/homeConstant";

let Initialstate = {};
console.log(5, Initialstate);

export function home(state = Initialstate, action) {
  switch (action.type) {
    case homeConstant.GET_fAQ_REQUEST:
      return {
        ...state,
        faq_status: status.IN_PROGRESS,
        faq_data: null,
      };
    case homeConstant.GET_fAQ_SUCCESS:
      return {
        ...state,
        faq_status: status.SUCCESS,
        faq_data: action.data,
      };
    case homeConstant.GET_fAQ_FAILURE:
      return {
        ...state,
        faq_status: status.FAILURE,
        faq_data: action.data,
      };

    case homeConstant.TOP_BANNER_REQUEST:
      return {
        ...state,
        top_banner_status: status.IN_PROGRESS,
        top_banner_data: null,
      };
    case homeConstant.TOP_BANNER_SUCCESS:
      return {
        ...state,
        top_banner_status: status.SUCCESS,
        top_banner_data: action.data,
      };
    case homeConstant.TOP_BANNER_FAILURE:
      return {
        ...state,
        top_banner_status: status.FAILURE,
        top_banner_data: action.data,
      };

    case homeConstant.CONTACT_REQUEST:
      return {
        ...state,
        contact_status: status.IN_PROGRESS,
        contact_data: null,
      };
    case homeConstant.CONTACT_SUCCESS:
      // console.log("Contact Reducer", action.data);
      return {
        ...state,
        contact_status: status.SUCCESS,
        contact_data: action.data,
      };
    case homeConstant.CONTACT_FAILURE:
      // console.log("Contact Reducer", action.data);
      return {
        ...state,
        contact_status: status.FAILURE,
        contact_data: action.data,
      };

    case homeConstant.CAR_REGISTER_FORM_REQUEST:
      return {
        ...state,
        carRegister_status: status.IN_PROGRESS,
        carRegister_data: null,
      };
    case homeConstant.CAR_REGISTER_FORM_SUCCESS:
      // console.log("Contact Reducer", action.data);
      return {
        ...state,
        carRegister_status: status.SUCCESS,
        carRegister_data: action.data,
      };
    case homeConstant.CAR_REGISTER_FORM_FAILURE:
      return {
        ...state,
        carRegister_status: status.FAILURE,
        carRegister_data: action.data,
      };

    default:
      return state;
  }
}
